import * as React from "react";
import { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import PhoneInput from "react-phone-input-2";

import { Button, TextField, Box, FormHelperText } from "@mui/material";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import { userAccountingInfoValidation } from "../../../../../../validations/accountingFormsValidation";
// import WordGroupQuery from "./WordGroupQuery";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: 4,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 10,
    // margin:1
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function EditUserAccountingInfo(props) {
  const {
    userAccountingInfo,
    handleSetUserAccountingInfo,
    setUserAccountingInfoToBack,
  } = props;
  const detectSize600px = useMediaQuery("(min-width:600px)");

  const handleSetValue = (key, valye) => {
    handleSetUserAccountingInfo(key, valye);
  };
  const checkValue = (type) => {
    if (
      userAccountingInfo[type] == "llmmt-loading" ||
      userAccountingInfo[type] == "llmmt-errorLoading"
    )
      return "";
    else return userAccountingInfo[type];
  };
  const initialValues = {
    firstName: checkValue("firstName"),
    lastName: checkValue("lastName"),
    mobileNumber: checkValue("mobileNumber"),
    identificationCardNumber: checkValue("identificationCardNumber"),
    // identificationCard: checkValue("identificationCard"),
  };

  const onSubmit = (values, props) => {
    let newValues = {
      firstName: values.firstName,
      lastName: values.lastName,
      mobileNumber: values.mobileNumber,
      identificationCardNumber: values.identificationCardNumber,
      // identificationCard: values.identificationCard,
    };
    setUserAccountingInfoToBack(newValues);
  };

  return (
    <Box sx={{ mt: 1 }}>
      <Formik
        initialValues={initialValues}
        validationSchema={userAccountingInfoValidation}
        onSubmit={onSubmit}
      >
        {(props) => (
          <Form>
            <TableContainer component={Paper}>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell
                      sx={{ width: detectSize600px ? "25%" : "50%" }}
                    >
                      ثبت و ویرایش مشخصات{" "}
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{ width: detectSize600px ? "75%" : "50%" }}
                    >
                      {" "}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"نام"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Field
                        type="text"
                        size="small"
                        as={TextField}
                        name="firstName"
                        label="نام "
                        placeholder="نام "
                        value={checkValue("firstName")}
                        onChange={(e) => {
                          props.setFieldValue("firstName", e.target.value);
                          handleSetValue("firstName", e.target.value);
                        }}
                      />
                      <FormHelperText
                        sx={{
                          m: 0,
                          p: 0,
                          color: "#f96767",
                          textAlign: "center",
                        }}
                      >
                        <ErrorMessage name="firstName" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"نام خانوادگی"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Field
                        type="text"
                        size="small"
                        as={TextField}
                        name="lastName"
                        label="نام خانوادگی"
                        placeholder="نام خانوادگی"
                        value={checkValue("lastName")}
                        onChange={(e) => {
                          props.setFieldValue("lastName", e.target.value);
                          handleSetValue("lastName", e.target.value);
                        }}
                      />
                      <FormHelperText
                        sx={{
                          m: 0,
                          p: 0,
                          color: "#f96767",
                          textAlign: "center",
                        }}
                      >
                        <ErrorMessage name="lastName" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"شماره موبایل"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Box sx={{ maxWidth: "200px" }}>
                        <PhoneInput
                          isValid={(value, country) => {
                            if (value.match(/12345/)) {
                              return "شماره نامعتبر";
                            } else if (value.match(/1234/)) {
                              return false;
                            } else {
                              return true;
                            }
                          }}
                          placeholder="شماره موبایل"
                          countryCodeEditable={false}
                          inputStyle={{ color: "black", width: "200px" }}
                          containerStyle={{
                            color: "black",
                            direction: "ltr",
                          }}
                          buttonStyle={{}}
                          country={"ir"}
                          enableSearch={true}
                          value={checkValue("mobileNumber").toString()}
                          onChange={(phone, country) => {
                            props.setFieldValue("mobileNumber", phone);
                            handleSetValue("mobileNumber", phone);
                          }}

                        // value={mobileNumber.toString()}
                        // onChange={(phone, country) => {
                        //   console.log(phone);
                        //   handleSetFieldValues(
                        //     props,
                        //     "mobileNumber",
                        //     phone
                        //   );
                        // }}
                        />
                      </Box>

                      <FormHelperText
                        sx={{
                          m: 0,
                          p: 0,
                          color: "#f96767",
                          textAlign: "center",
                        }}
                      >
                        <ErrorMessage name="mobileNumber" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  {/* 
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"شماره تلفن همراه"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Field
                        type="number"
                        size="small"
                        as={TextField}
                        name="mobileNumber"
                        label="شماره تلفن همراه"
                        placeholder="شماره تلفن همراه"
                        value={checkValue("mobileNumber")}
                        onChange={(e) => {
                          props.setFieldValue("mobileNumber", e.target.value);
                          handleSetValue("mobileNumber", e.target.value);
                        }}
                      />
                      <FormHelperText
                        sx={{
                          m: 0,
                          p: 0,
                          color: "#f96767",
                          textAlign: "center",
                        }}
                      >
                        <ErrorMessage name="mobileNumber" />
                      </FormHelperText>
                      <FormControl style={{ minWidth: 120 }}>
                        <InputLabel id="demo-simple-select-label">
                          پیش شماره
                        </InputLabel>
                        <Select
                          size="small"
                          label="areaCodeMobileNumber"
                          name="areaCodeMobileNumber"
                          id="areaCodeMobileNumber"
                          value={checkValue("areaCodeMobileNumber") || ""}
                          onChange={(e) => {
                            props.setFieldValue(
                              "areaCodeMobileNumber",
                              e.target.value
                            );
                            handleSetValue(
                              "areaCodeMobileNumber",
                              e.target.value
                            );
                          }}
                          // onChange={(e) => {
                          //   setAreaCodeMobileNumber(e.target.value);
                          //   props.setFieldValue(
                          //     "areaCodeMobileNumber",
                          //     e.target.value
                          //   );
                          // }}
                        >
                          <MenuItem autoFocus key={0} value={98}>
                            +98 ایران
                          </MenuItem>
                          {Object.keys(areaCodeList).map((option, index) => (
                            <MenuItem key={index + 1} value={option}>
                              {`${areaCodeList[option]} +${option}`}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText
                          sx={{ color: "#f96767", textAlign: "center" }}
                        >
                          <ErrorMessage name="areaCodeMobileNumber" />
                        </FormHelperText>
                      </FormControl>
                    </StyledTableCell>
                  </StyledTableRow> */}

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"شماره کارت ملی"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Field
                        sx={{ minWidth: 200 }}
                        size="small"
                        type="number"
                        as={TextField}
                        name="identificationCardNumber"
                        label="شماره کارت ملی"
                        placeholder="شماره کارت ملی"
                        value={checkValue("identificationCardNumber")}
                        onChange={(e) => {
                          props.setFieldValue(
                            "identificationCardNumber",
                            e.target.value
                          );
                          handleSetValue(
                            "identificationCardNumber",
                            e.target.value
                          );
                        }}
                      />
                      <FormHelperText
                        sx={{
                          m: 0,
                          p: 0,
                          color: "#f96767",
                          textAlign: "center",
                        }}
                      >
                        <ErrorMessage name="identificationCardNumber" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  {/* <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"اسکن کارت ملی"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Field
                        sx={{ minWidth: 200 }}
                        size="small"
                        type="text"
                        as={TextField}
                        name="identificationCard"
                        label="اسکن کارت ملی"
                        placeholder="اسکن کارت ملی"
                        value={checkValue("identificationCard")}
                        onChange={(e) => {
                          props.setFieldValue(
                            "identificationCard",
                            e.target.value
                          );
                          handleSetValue("identificationCard", e.target.value);
                        }}
                        helperText={
                          <FormHelperText
                            sx={{
                              m: 0,
                              p: 0,
                              color: "#f96767",
                              textAlign: "center",
                            }}
                          >
                            <ErrorMessage name="identificationCard" />
                          </FormHelperText>
                        }
                      />
                    </StyledTableCell>
                  </StyledTableRow> */}
                </TableBody>
              </Table>
            </TableContainer>
            <Button
              type="submit"
              variant="contained"
              sx={{ m: 2 }}
              color="success"
            >
              ذخیره
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
}

const areaCodeList = {
  994: "آذربایجان",
  54: "آرژانتین",
  27: "آفریقای جنوبی",
  236: "آفریقای مرکزی",
  355: "آلبانی",
  49: "آلمان",
  1: "آمریکا",
  244: "آنگولا",
  43: "اتریش",
  251: "اتیوپی",
  375: "بلاروس",
  962: "اردن",
  374: "کد ارمنستان",
  598: "اروگوئه",
  291: "اریتره",
  7371: "ازبکستان",
  34: "اسپانیا",
  61: "کد استرالیا",
  372: "استونی",
  43: "اطریش",
  93: "افغانستان",
  213: "الجزایر",
  503: "السالوادور",
  971: "کد امارات",
  62: "اندونزی",
  44: "کد انگلستان",
  25: "اوگاندا",
  380: "اوکراین",
  39: "ایتالیا",
  98: "ایران",
  353: "ایرلند",
  593: "اکوادور",
  354: "ایسلند",
  18094: "باربادوس",
  18093: "باهاما",
  973: "بحرین",
  55: "برزیل",
  673: "بروئنی",
  32: "بلژیک",
  359: "بلغارستان",
  880: "بنگلادش",
  229: "بنین",
  267: "بوتان",
  387: "بوسنی و هرزگوین",
  591: "بولیوی",
  595: "پاراگوئه",
  507: "پاناما",
  92: "پاکستان",
  351: "پرتغال",
  51: "پرو",
  95: "پنال",
  992: "تاجیکستان",
  255: "تانزانیا",
  66: "تایلند",
  886: "تایوان",
  1868: "ترینیداد",
  7363: "ترکمنستان",
  90: "ترکیه",
  216: "تونس",
  676: "تونگا",
  18099: "جامائیکا",
  359: "جزایر قناری",
  692: "جزایرمارشال",
  237: "چاد",
  86: "چین",
  42: "چک",
  45: "دانمارک",
  1767: "دومینیکا",
  1809: "دومینیکن",
  250: "رو آندا",
  7095: "روسیه",
  40: "رومانی",
  243: "زئیر",
  260: "زامبیا",
  64: "زلاند نو",
  263: "زیمبابوه",
  81: "ژاپن",
  225: "ساحل عاج",
  684: "ساموآ آمریکا",
  685: "ساموا غربی",
  94: "سریلانکا",
  1758: "سنت لوسیا",
  1784: "سنت وینسنت",
  1869: "سنت کیتس",
  65: "سنگاپو",
  221: "سنگال",
  46: "سوئد",
  41: "سوئیس",
  249: "سودان",
  597: "سورینام",
  963: "سوریه",
  252: "سومالی",
  148: "سیشل",
  56: "شیلی",
  381: "صربستان و مونته نگرو",
  966: "کد کشور عربستان",
  964: "عراق",
  968: "عمان",
  233: "غنا",
  33: "فرانسه",
  358: "فنلاند",
  679: "فیجی",
  63: "فیلیپین",
  357: "قبرس",
  7331: "قرقیزستان",
  974: "قطر",
  855: "کامبوج",
  237: "کامرون",
  1: "کانادا",
  82: "کره جنوبی",
  850: "کره شمالی",
  385: "کرواسی",
  506: "کاستاریکا",
  57: "کلمبیا",
  242: "کنگو",
  254: "کنیا",
  53: "کوبا",
  269: "کومور",
  965: "کویت",
  241: "گابون",
  220: "گامبیا",
  955: "گرجستان",
  1473: "گرنادا",
  502: "گواتمالا",
  671: "گوام",
  224: "گینه",
  240: "گینه استوایی",
  245: "گینه بیسائو",
  856: "لائوس",
  961: "لبنان",
  266: "لسوتو",
  48: "لهستان",
  352: "لوکزامبورگ",
  231: "لیبریا",
  218: "لیبی",
  265: "مالاوی",
  356: "مالت",
  960: "مالدیو",
  60: "مالزی",
  223: "مالی",
  36: "مجارستان",
  212: "مراکش",
  20: "مصر",
  976: "مغولستان",
  389: "مقدونیه",
  222: "موریتانی",
  230: "موریس",
  258: "موزامبیک",
  95: "میانمار",
  52: "مکزیک",
  674: "نائورا",
  264: "نامیبیا",
  977: "نپال",
  47: "نروژ",
  267: "نگارا پرونئی دارالسلام",
  227: "نیجر",
  505: "نیکاراگوئه",
  509: "هائی تی",
  31: "هلند",
  91: "هند",
  504: "هندوراس",
  752: "هنگ کنگ",
  39: "واتیکان",
  58: "ونزوئلا",
  84: "ویتنام",
  969: "یمن جنوبی",
  967: "یمن شمالی",
  381: "یوگسلاوی",
  30: "یونان",
};
